module.exports = __webpack_public_path__ + "img/ticket_ko2.4a7cad7b.png";